import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopPescaFormService } from './scheda-coop-pesca-form.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [SchedaCoopPescaFormService],
})
export class SchedaCoopPescaFormModule {}